//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Kirbyimage from './kirbyimage.vue'

export default
{
    name: "articlecard",
    props:{
        article: Object
    },
    components:{
        Kirbyimage
    }
}

